// extracted by mini-css-extract-plugin
module.exports = {"objectives":"ObjectivePlaceholder_objectives__28-St","wrapper":"ObjectivePlaceholder_wrapper__j8Mcp"};